export default "/images/favicon.png?19318c26039d59297cd004c2ad239f40";